import React from 'react';
import { ColumnDefinitionEnum, BoloQueueView } from '@mark43/cad-api';
import { WorkspaceQueueColumn } from '../../panels/workspace-queue-column';
import columnDefinitionEnum from '../../queues/column-definition.enum';
import { PriorityBox } from '../../common/components/fr-queues/priority-box';
import { BaseCellStyledBox } from '../../common/components/fr-queues/base-cell-styled-box';
import { FrTooltipCell } from '../../common/components/fr-queues/fr-tooltip-cell';
import { cssVar } from '@cad-arc';
import { DataPrivacy } from '../../common/components/datadog-privacy';
import { FR_BOLO_QUEUE_UNMASKED_COLUMN } from '../../common/components/fr-queues/constants';

export const FrBoloCompactQueueCell = ({
    col,
    data,
}: {
    col: WorkspaceQueueColumn;
    data: BoloQueueView;
}) => {
    const item = columnDefinitionEnum[col.columnDefinition];

    if (item.name === ColumnDefinitionEnum.BOLO_PRIORITY.name) {
        return (
            <DataPrivacy privacy="unmask">
                <BaseCellStyledBox
                    $fontSize={cssVar('arc.fontSizes.sm')}
                    $padding={cssVar('arc.space.half')}
                    borderRadius={cssVar('arc.radii.base')}
                >
                    <PriorityBox isFlashing={data.isPriority1}>
                        {data.priorityAbbreviation}
                    </PriorityBox>
                </BaseCellStyledBox>
            </DataPrivacy>
        );
    }

    const privacy = FR_BOLO_QUEUE_UNMASKED_COLUMN.has(item.name) ? 'unmask' : 'mask';
    return (
        <DataPrivacy privacy={privacy}>
            <FrTooltipCell text={item.getFlatValue(data)} />
        </DataPrivacy>
    );
};
